import React, { FC } from 'react';
import { formatDate } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@mui/material';
import FormattedAddress from 'components/shared/address/formatted-address.component';
import { SimpleOrderInput } from 'models/order-input/simple-order';

type DeliverySummaryProps = {
    order: SimpleOrderInput;
};
const DeliverySummary: FC<DeliverySummaryProps> = ({ order }) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    const time = order.deliveryDetails?.time;

    return (
        <Grid container>
            <Grid item xs={12} md={3}>
                <Box mb={0.5}>
                    <Typography variant="subtitle2">{translate('orders:PICKUP_LOCATION')}</Typography>
                </Box>
                <Box>
                    <Box>{order.deliveryDetails.pickUpLocation?.name}</Box>
                    <Box>
                        <FormattedAddress
                            hideCountry
                            address={order.deliveryDetails.pickUpLocation?.contact?.address}
                        />
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={3}>
                <Box mb={0.5}>
                    <Typography variant="subtitle2">{translate('orders:DELIVERY_DESTINATION')}</Typography>
                </Box>
                <Box>
                    <Box>{order.deliveryDetails.destination?.name}</Box>
                    <Box>
                        <FormattedAddress hideCountry address={order.deliveryDetails.destination?.contact?.address} />
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={3}>
                <Box mb={0.5}>
                    <Typography variant="subtitle2">{translate('orders:DELIVERY_DATE')}</Typography>
                </Box>
                <Box display="flex">
                    <Box>{formatDate(order.deliveryDetails.date || new Date(), 'date')}</Box>
                    {time?.hour || time?.hour === 0 ? (
                        <Box ml={1}>
                            {time.hour <= 9 ? '0' + time.hour : time.hour}:
                            {time?.minute ? (time.minute <= 9 ? '0' + time.minute : time.minute) : '00'}
                        </Box>
                    ) : undefined}
                </Box>
            </Grid>
        </Grid>
    );
};

export default DeliverySummary;
